import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import { ApiService } from '@app/services/api/api.service';

import {
  tap
} from 'rxjs/operators';

import {
  ShippingmarksActionTypes,
  ShippingmarksDownload,
  ShippingmarksDownloadAll,
  ShippingmarksDownloadPDF
} from '@core/actions/shippingmarks.actions';

import { FlashService } from '@app/services/flash.service';

@Injectable()
export class ShippingmarksEffects {
  @Effect({ dispatch: false })
  shippingmarksDownload$ = this.actions$.pipe(
    ofType<ShippingmarksDownload>(
      ShippingmarksActionTypes.ShippingmarksDownload
    ),
    tap(action => {
      return this.api.exportShippingmarks(
        action.ProviderId,
        action.FollowId,
        action.filename
      );
    })
  );

  @Effect({ dispatch: false })
  shippingmarksDownloadAll$ = this.actions$.pipe(
    ofType<ShippingmarksDownloadAll>(
      ShippingmarksActionTypes.ShippingmarksDownloadAll
    ),
    tap(action => {
      return this.api.exportAllShippingmarks(
        action.FollowId,
        action.UserId,
        action.data
      );
    })
  );

  @Effect({ dispatch: false })
  shippingmarksDownloadPDF$ = this.actions$.pipe(
    ofType<ShippingmarksDownloadPDF>(
      ShippingmarksActionTypes.ShippingmarksDownloadPDF
    ),
    tap(action => {
      return this.api.exportShippingmarksPDF(
        action.ProviderId,
        action.FollowId,
        action.filename
      );
    })
  );

  constructor(
    private actions$: Actions,
    private flash: FlashService,
    private api: ApiService
  ) {}
}
